import { WalletToYouzanProps, defaults } from '@/components/ui/WalletToYozan.ts';
import { gravComponentSchema } from '../deep-form-grav';


const { s, l, toExport } = gravComponentSchema<WalletToYouzanProps>({
  title: 'Wallet To Youzan History',
  link: '',
  text: text(),
},
  defaults,
);

export default toExport;

s.add('walletId').as(l.clone('walletId'))
  .title('Source wallet').mandatory()
  .col(4);


function text() {
  return `
<b>Wallet To Youzan</b>
`;
}
